import React, { Component } from 'react';
import { AdminDashboardTheme } from '../../../../theme';


export class Dashboard extends Component {
  
  render() {
    return (
        <AdminDashboardTheme />
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/modules/screens/dashboard/Dashboard/components/Dashboard.js